import { Card, Skeleton, Space } from "antd";
import Avatar from "../../../assets/icons/Avatar.svg";

const styles = {
  height: "30px",
};

const ListCard = ({ list, label, loading }) => {
  return (
    <>
      <p className="text-md p-0 m-0">{label}</p>
      <Card className="rounded-2xl bg-white xl:relative">
        <div className="border-solid border-inputFieldGrey rounded-sm p-2">
          {loading &&
            Array(3)
              .fill()
              .map(() => (
                <Space className="pb-1">
                  {" "}
                  <Skeleton.Avatar
                    active={"true"}
                    size={"small"}
                    shape={"circle"}
                  />
                  <Skeleton.Input active={true} size={"small"} />
                </Space>
              ))}

          {!loading &&
            list?.map((item) => (
              <div className="space-align-block pb-1">
                <Space align="center" style={styles}>
                  <img src={Avatar} style={styles} alt="infocard-img" />
                  <div>
                    <p className="text-xs p-0 m-0">{item?.name}</p>
                    {item?.orderNo && (
                      <p className="text-xs text-primaryOrange p-0 m-0">
                        ORDER #{item?.orderNo}
                      </p>
                    )}
                    {item?.timeStamp && (
                      <p className="text-xs text-grey p-0 m-0">
                        {item?.timeStamp}
                      </p>
                    )}
                  </div>
                </Space>
              </div>
            ))}
        </div>
      </Card>
    </>
  );
};

export default ListCard;
